import * as React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  WithStyles,
  withStyles,
  Divider,
} from "@material-ui/core";
import EditableTableComponent from "../components/EditableTableComponent";
import { ConfigurationService } from "../services/ConfigurationService";
import { getRoles, ROLES } from "../constants/constants";
import LoadingComponents from "../components/LoadingComponents";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";

export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = () =>
  createStyles({
    image: {
      width: 128,
      height: 128,
    },
    img: {
      "max-width": 120,
      "max-height": 120,
      overflow: "hidden",
    },
  });
interface Props extends WithStyles<typeof styles> {
  dialogTitle: any;
  open: any;
  handleClose: any;
  handleOnSubmit: any;
  defaultValue?: any;
}

class AddAccessConfigurationsDialog extends React.Component<Props> {
  state = {
    allAccessRolesRules: new Array<any>(),
    accessRules: new Array<any>(),
    isLoading: false,
    otherRolesAccessRules: new Array<any>(),
  };
  componentDidMount = () => {
    this.getConfigurationAccess();
  };
  getConfigurationAccess = () => {
    let configurationService: ConfigurationService = new ConfigurationService();
    configurationService.getAccess().then((resp) => {
      if (resp && resp.success && resp.data) {
        let rules = getRoles(ROLES.KRODAC_ADMIN, resp.data);
        let accessRules = this.getPopulateAccessRule(rules);
        this.setState({
          accessRules: accessRules,
          allAccessRolesRules: resp.data,
        });
      }
    });
  };

  getPopulateAccessRule = (rules: any) => {
    let accessRules = new Array<any>();
    rules.static
      .sort((a: any, b: any) =>
        a.permission.split(":")[0] > b.permission.split(":")[0] ? 1 : -1
      )
      .map((ruleItem: any) => {
        if (ruleItem.permission.split(":").length > 1) {
          accessRules.push({
            field: ruleItem.permission.split(":")[0],
            permissionType: ruleItem.permission.split(":")[1],
          });
        }
        return null;
      });
    return accessRules;
  };
  onAddDataChanged = (newData: any) => {
    this.setState((prevState: any) => {
      const accessRules = [...prevState.accessRules];
      accessRules.push(newData);
      return { ...prevState, accessRules };
    });
  };
  onEditDataChanged = (newData: any, oldData: any) => {
    this.setState((prevState: any) => {
      const accessRules = [...prevState.accessRules];
      accessRules[accessRules.indexOf(oldData)] = newData;
      return { ...prevState, accessRules };
    });
  };
  onDeleteataChanged = (oldData: any) => {
    let otherRolesAccessRules = new Array<any>();
    this.state.allAccessRolesRules.map((accessRuleItem: any) => {
      if (accessRuleItem.role !== ROLES.KRODAC_ADMIN) {
        let filterStaticItems = accessRuleItem.static.filter(
          (staticItem: any) => {
            return (
              staticItem.permission !==
              `${oldData.field}:${oldData.permissionType}`
            );
          }
        );
        accessRuleItem.static = filterStaticItems;
        otherRolesAccessRules.push(accessRuleItem);
      }
      return null;
    });
    this.setState((prevState: any) => {
      const accessRules = [...prevState.accessRules];
      accessRules.splice(accessRules.indexOf(oldData), 1);
      return {
        ...prevState,
        accessRules,
        otherRolesAccessRules: otherRolesAccessRules,
      };
    });
  };

  handleOnSave = () => {
    let superAdminRules = {
      role: ROLES.KRODAC_ADMIN,
      static: new Array<any>(),
    };
    this.state.accessRules.map((accessRuleItem: any) => {
      superAdminRules.static.push({
        permission: `${accessRuleItem.field}:${accessRuleItem.permissionType}`,
        enabled: true,
      });
      return null;
    });
    this.addAccessConfiguration(superAdminRules);
  };

  addAccessConfiguration = (superAdminRules: any) => {
    const { handleOnSubmit, handleClose } = this.props;
    this.setState({
      isLoading: true,
    });
    let configurationService: ConfigurationService = new ConfigurationService();
    configurationService.addAccess(superAdminRules).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.added) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Added Successfully",
        });
        handleClose();
        handleOnSubmit();
      }
      if (resp && resp.success && resp.updated) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Updated Successfully",
        });
        handleClose();
        handleOnSubmit(this.state.otherRolesAccessRules);
      }
    });
  };

  render() {
    const { dialogTitle, open, handleClose } = this.props;
    return (
      <React.Fragment>
        <LoadingComponents isLoading={this.state.isLoading} />
        <Dialog
          open={open}
          maxWidth={"md"}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-slide-title">{dialogTitle}</DialogTitle>
          <Divider />
          <DialogContent>
            <EditableTableComponent
              title={"Add Acess Configurations"}
              columns={[
                {
                  title: "Field",
                  field: "field",
                  width: 200,
                },
                {
                  title: "Permission Type",
                  field: "permissionType",
                  width: 200,
                },
              ]}
              customDeleteObject={{
                message: "Are you sure you want to delete this row",
                additionalMessage:
                  "Please note this permission will be deleted in all the roles.",
              }}
              data={this.state.accessRules}
              onAddDataChanged={this.onAddDataChanged}
              onEditDataChanged={this.onEditDataChanged}
              onDeleteataChanged={this.onDeleteataChanged}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleClose()}>{"Close"}</Button>
            <Button onClick={() => this.handleOnSave()}>{"Save"}</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddAccessConfigurationsDialog);
